import {
  Box,
  Link,
  List,
  ListItem,
  ListItemText,
  SxProps,
  Typography
} from '@mui/material';
import { Button } from 'system/atoms';
import { BackButton } from 'components/Buttons';
import { getSupportUrl, openSupportUrl } from 'core/utils/supportUrl';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import {
  whatsAppOnboardingStepMapper,
  WhatsAppOnboardingSteps
} from '../constants';

type Props = {
  handleNext: (step?: number) => void;
};

const listItemStyle: SxProps = {
  display: 'list-item'
};

export const UserWithNoPhoneNumberStep: React.FC<Props> = ({ handleNext }) => {
  return (
    <Box>
      <BackButton
        onClick={() =>
          handleNext(
            whatsAppOnboardingStepMapper[WhatsAppOnboardingSteps.PHONE_NUMBER]
          )
        }
      />
      <Typography variant="h6" mt={3}>
        Don't worry!
      </Typography>
      <List sx={{ listStyle: 'decimal' }} disablePadding>
        <ListItem>
          <ListItemText
            primary={
              <Typography>
                <Link
                  href={getSupportUrl({
                    ticketForm: 'purchase_a_mobile_number'
                  })}
                  target="_blank"
                >
                  Ask Popp's support team
                </Link>{' '}
                to acquire a number for you. The process may take a few days
              </Typography>
            }
            sx={listItemStyle}
          />
        </ListItem>

        <ListItem>
          <ListItemText
            primary={
              <Typography>
                Our team may contact you to collect any further information{' '}
              </Typography>
            }
            sx={listItemStyle}
          />
        </ListItem>

        <ListItem>
          <ListItemText
            primary={
              <Typography>
                We'll let you know when the number is ready so you can follow
                the setup process again
              </Typography>
            }
            sx={listItemStyle}
          />
        </ListItem>
      </List>

      <Box mt={4}>
        <Button
          endIcon={<MailOutlineIcon />}
          variant="primary"
          onClick={() =>
            openSupportUrl({ ticketForm: 'purchase_a_mobile_number' })
          }
        >
          Send request to Popp
        </Button>
      </Box>
    </Box>
  );
};
